module.exports = __webpack_public_path__ + "img/help_icon_selected.51e7eedc.svg";